//TODO : fieldFormat must execute after the field lost focus
//TODO : fieldFormat must accept multiple functions using pipe or compose functions.

/**
 * @typedef {Object} FORMS_PARAM  form params
 * @property {String} selector Form container. Query string.
 * @property {String} confirmTxt Confirm Pop Up Message before submit form.
 * @property {REPLACEMODE} insertionMode reponse content after submit insertion mode (only works for Ajax mode)
 * @property {String} updateTargetId: location where to insert the HTML response, depends on insertionMode param.
 * @property {String} method Request method.
 * @property {String} url Target Server web method.
 * @property {GRECAPTCHA_OPTIONS} recaptchaOptions recaptcha options.
 * @property {String} recaptchaError captcha message error.
 * @property {Boolean} isSubmitEnable  enable/disable the submit button.
 * @property {Function} onBeforeSubmit it executes a function before submit the form - must return true otherwise the process is cancelled.
 * @property {Function} onBegin: it executes a function before AJAX communications.
 * @property {Function} onComplete: it executesa function after AJAX communications.
 * @property {Function} onSuccess: it executes afunction after AJAX successful operation.
 * @property {Function} onFailure: it executes a function if an error ocurred in the AJAX communications.
 * @property {Function} sanitizeFn: Sanitize function.
 * @property {Object} dataObject: previous data to fill the form.
 * @property {Boolean} enableAjax: enable ajax form.
 */

/**
 * @typedef {Object} FORM_RESULT  data to send.
 * @property {Boolean} IsValid True to send the fields.
 * @property {Object} Fields object fields.
 */
// TODO:  adjust to accept "the Default Model Binder page 638" from PRO ASP NET MVC5

// TODO: add data-list-field-object logic
// TODO: add  format to the fields
// TODO: 1 .- insert logic for insertionMode
//            updateTargetId
//              loader
//              method
//              url
//              onBegin
//              onComplete
//              onFailure
//              onSuccess
// TODO: 2.- logic for formdata
// TODO: 3.- Logic for upload files
// TODO: 4.- Logic for invisible recaptcha

//TODO: make aware that all validations must run in every field regardless if one of them is changed
/**
 * @class
 * manage form fields
 */
class Forms_JS {
    /**
     * @constructor
     * @param {FORMS_PARAM} paramOptions forms options
     */
    constructor(paramOptions) {
        /**
         * default options
         * @type {FORMS_PARAM}
         */
        let Options = {
            confirmTxt: '', //
            insertionMode: JFM_CONST.REPLACEMODE.NOREPLACE, //
            updateTargetId: '',
            method: 'Post', //
            url: '',
            recaptchaOptions: null,
            recaptchaError: '',
            sanitizeFn: null,
            isSubmitEnable: true,
            onBeforeSubmit: null,
            onBegin: null,
            onComplete: null,
            onSuccess: null,
            onFailure: null,
            dataObject: null,
            enableAjax: false
        };

        Object.assign(Options, paramOptions);

        /**
         * Form container
         * @type {HTMLFormElement|HTMLDivElement}
         */
        this.Container = document.querySelector((typeof Options.selector === 'string') ? Options.selector : null);
        /**
         * Form Confirmation text.
         * @type {String}
         */
        this.ConfirmTxt = (typeof Options.confirmTxt === 'string') ? Options.confirmTxt : '';
        /**
         * Recaptcha options.
         * @type {GRECAPTCHA_OPTIONS}
         */
        this._recaptchaOptions = (typeof Options.recaptchaOptions === 'object') ? Options.recaptchaOptions : null;
        /**
         * Has Recaptcha Flag
         * @type {Boolean}
         */
        this.HasRecaptcha = !!this._recaptchaOptions;
        /**
         * Recaptcha options.
         * @type {String}
         */
        this._recaptchaError = (typeof Options.recaptchaError === 'string') ? Options.recaptchaError : '';
        /**
         * Recaptcha control.
         * @type {RecaptchaWidget}
         */
        this.WidgetRecaptcha = null;
        /**
         * enable/disable submit
         * @type {Boolean}
         * @private
         */
        this._IsSubmitEnable = !!Options.isSubmitEnable;
        /**
         * raise a function before submit the form. If returns false the submit event is cancelled
         * @type {Function}
         */
        this.OnBeforeSubmit = (typeof Options.onBeforeSubmit === 'function') ? Options.onBeforeSubmit : null;
        /**
         * Form Fields Collection
         * @type {Array.<HTMLInputElement|HTMLTextAreaElement>}
         */
        this.FieldCollection = null;
        /**
         * Submit buttons
         * @type {Array.<HTMLInputElement|HTMLButtonElement>}
         */
        this.SubmitBtnCollection = null;
        /**
         * Form validation Layer.
         * @type {ValidationForm_JS}
         */
        this.ValidationForm = null;
        /**
         * santize function
         * @type {Function}
         */
        this.SanitizeFn = Options.sanitizeFn;
        /**
         * data to fill the form.
         * @type {Object}
         */
        this._data = Options.dataObject;
        /**
         * Enable Ajax Mode.
         * @type {Boolean}
         */
        this.EnableAjax = Options.enableAjax;
        /**
         * Submit options
         */
        this.Submit = {
            /**
             * Submit method
             * @type {String}
             */
            method: Options.method,
            /**
             * Submit url
             * @type {String}
             */
            url: Options.url,
            /**
             * on begin submit form
             * @type {Function}
             */
            onBegin: Options.onBegin,
            /**
             * on complete submit form
             * @type {Function}
             */
            onComplete: Options.onComplete,
            /**
             * on Success submit form
             * @type {Function}
             */
            onSuccess: Options.onSuccess,
            /**
             * on failure submit form
             * @type {Function}
             */
            onFailure: Options.onFailure
        }

        this.init();
    }
    /**
     * return object data
     * @returns {Object} object data
     */
    get Data() {
        return this._data;
    }
    //TODO: test by subscriber
    set Data(value) {
        const isSubmitEnable = this.IsSubmitEnable;
        this._data = typeof value === 'object' ? value : null;
        if (!!this._data && Object.keys(this._data).length > 0) {
            !!isSubmitEnable && (this.IsSubmitEnable = false);
            this.loadData(this._data);
            !!isSubmitEnable && (this.IsSubmitEnable = true);
        }
    }

    get IsSubmitEnable() {
        return this._IsSubmitEnable;
    }
    /**
     * Enable / unenable fields
     * @param {Boolean} value  true for enable submit button.
     */
    set IsSubmitEnable(value) {
        //Enable / unenable fields
        this._IsSubmitEnable = !!value;
        !!this.SubmitBtnCollection && this.SubmitBtnCollection.forEach(s => (s.disabled = !this.IsSubmitEnable));
    }
    /**
     * Initialize Forms JS
     */
    init() {
        // valid params
        //Container
        if (!this.Container || !(JFM_CONST.CONTAINER_COLLECTION.some(c => c === this.Container.tagName.toUpperCase()))) {
            throw new Error(`invalid form container:${this.Container.tagName}`);
        }

        if (!this.EnableAjax && !(this.Container instanceof HTMLFormElement)) {
            throw new Error(`Only a form can be submitted. Tag container: ${this.Container.tagName}`);
        }

        //Recaptcha site key config
        if (!!this._recaptchaOptions && !this._recaptchaOptions.siteKey) {
            throw new Error(`Missing site key in Recaptcha options`);
        }
        //Look for submit button
        this.SubmitBtnCollection = this.Container.querySelectorAll('input[type="submit"], button[type="submit"], a[role="submit"]');
        if (!this.SubmitBtnCollection || this.SubmitBtnCollection.length == 0) {
            throw new Error(`Missing submit button: looking for input[type="submit"] or button[type="submit"] or a[role="submit"]`);
        }
        //enable /disable submit button
        this.IsSubmitEnable = this._IsSubmitEnable;
        //has recaptcha
        // set up all recaptcha
        !!this.HasRecaptcha && this.initRecaptcha();

        //Init custom widget controls.
        this.initWidgets();
        //Fill the form with data
        if (typeof this._data == 'object' && !!this._data && Object.keys(this._data).length > 0) {
            this.Data = this._data;
        }
        //Get input fields
        this.FieldCollection = this.Container.querySelectorAll('input[data-val="true"], textarea[data-val="true"], select[data-val="true"]');
        // convert to array 
        if (!!this.FieldCollection && this.FieldCollection.length > 0) {
            this.FieldCollection = [].slice.call(this.FieldCollection, 0);
        } else {
            throw new Error(`Missing form fields: set [data-val="true"] attribute`);
        }
        //attach events for validation each fields
        this.ValidationForm = new ValidationForm_JS(this.Container, this.FieldCollection)
        //add submit event
        this.addSubmitEvent();
    }
    /**
     * set up all recaptcha
     */
    initRecaptcha() {
        if (!!grecaptcha) {
            const _recaptchaCollection = this.Container.querySelectorAll('input[data-widget="recaptcha"]');
            this.WidgetRecaptcha = new RecaptchaWidget(grecaptcha, _recaptchaCollection, this._recaptchaError, this._recaptchaOptions, this.afterReceiveCaptcha.bind(this));
        } else {
            throw new Error(`Missing grecaptcha object for Google Recaptcha V2`);
        }
    }
    /**
     * Init custom widget controls.
     */
    initWidgets() {
        const _fieldCollection = this.Container.querySelectorAll('input[data-widget], textarea[data-widget], select[data-widget]');
        if (!!_fieldCollection) {
            [].slice.call(_fieldCollection, 0)
                .forEach(w => {
                    switch (w.dataset.widget.toLowerCase()) {
                        case 'date':
                            w.widget = new DatePartWidget(w);
                            break;
                        case 'password':
                            w.widget = new PasswordWidget(w);
                            break;
                    }
                });
        }
    }
    /**
     * register submit event.
     */
    addSubmitEvent() {
        const isSubmitEvent = this.Container instanceof HTMLFormElement;
        if (isSubmitEvent) {
            this.Container.addEventListener('submit', this.onSubmit.bind(this), false);
        } else {
            this.SubmitBtnCollection.forEach(btn => btn.addEventListener('click', this.onSubmit.bind(this), false));
        }
    }
    /**
     * Reset form
     */
    reset() {
        if (this.Container instanceof HTMLFormElement) {
            this.Container.reset();
            this.Container.querySelectorAll('input,textarea,select').forEach(f => f.classList.remove('is-valid', 'is-invalid'));
        } else {
            this.FieldCollection.forEach(f => {
                switch (f.type.toLowerCase()) {
                    case 'checkbox':
                        f.checked = false;
                        break;
                    case 'radio':
                        f.checked = false;
                        break;
                    case "select-one":
                    case "select-multiple":
                        f.value = null;
                        break;
                    case "file":
                        f.value = null;
                        break;
                    default:
                        f.value = null;
                        break;
                }
                f.classList.remove('is-valid', 'is-invalid');
            });
        }
        //Reset recaptcha
        if (this.HasRecaptcha) {
            this.WidgetRecaptcha.reset();
        }
    }
    /**
     * send form if fields are correct.
     */
    sendForm() {
        this.processFormAsync();
    }
    /**
     * validate Form
     */
    async processFormAsync() {
        /**
         * @type {VALIDATION_RESPONSE}
         */
        let _response = {}, //detail validation response
            SanitizeFn = (typeof this.SanitizeFn === 'function') ? this.SanitizeFn : DOMUtility_JS.encodeHTMLEntities;

        //disable submit process in the current form
        this.IsSubmitEnable = false;

        // sanitize fields
        this.FieldCollection = this.Container.querySelectorAll('input[data-val="true"], textarea[data-val="true"], select[data-val="true"]');
        this.FieldCollection.forEach(f => (f.value = SanitizeFn(f.value)));
        // format strings values
        // data-field-format must be a preexisting function in the String object
        //  data-field-format-params args for the function in an array format
        this.FieldCollection.forEach(f => {
            let jsonParams = '',
                Fn = null;
            if (!!f.dataset.fieldFormat && !!f.value && typeof f.value[f.dataset.fieldFormat] === 'function') {
                //get params
                if (!!f.dataset.fieldFormatParams) {
                    jsonParams = JSON.parse(f.dataset.fieldFormatParams);
                }

                Fn = f.value[f.dataset.fieldFormat];

                if (Array.isArray(jsonParams)) {
                    f.value = Fn.apply(f.value, jsonParams);
                } else {
                    f.value = Fn.call(f.value);
                }
            }
        });
        // validate form
        _response = await this.ValidationForm.evalFormAsync();
        // get captchatoken
        if (this.HasRecaptcha) {
            this.WidgetRecaptcha.getResponse(_response); //--> launch afterReceiveCaptcha method then returnValidationResponse
        }
        else {
            this.returnValidationResponse(_response);
        }
    }
    /**
     * process form
     * @param {string} tokenValue captcha response
     * @param {VALIDATION_RESPONSE} formValidationResponse 
     */
    afterReceiveCaptcha(tokenValue, formValidationResponse) {
        /**
         * @type {VALIDATION_RESPONSE}
         */
        const _formValidationResponse = this.ValidationForm.validateCaptchaToken(this.WidgetRecaptcha, formValidationResponse, tokenValue)
            ;
        this.returnValidationResponse(_formValidationResponse);
    }
    /**
     * return validation response
     * @param {VALIDATION_RESPONSE} formValidationResponse 
     */
    returnValidationResponse(formValidationResponse) {
        const _errorSumaryHTML = this.Container.querySelector('[data-summary-error="true"]'), //html panel error.
            _HtmlUL = document.createElement('UL'), // html <ul>
            _response = formValidationResponse
            ;
        let objectFields = {} // data object to send
            ;
        //Clean error messages
        !!_errorSumaryHTML && (_errorSumaryHTML.innerHTML = '');
        // print all errors
        if (!_response.IsValid) {
            if (!!_errorSumaryHTML) {
                _response.Errors.forEach((v, k) => {
                    const _descriptionField = (!!k.hasAttribute && k.hasAttribute('aria-describedby')) ? `${k.getAttribute('aria-describedby')}:` : '',
                        _HtmlIL = document.createElement('LI');
                    _HtmlIL.classList.add('text-start');
                    _HtmlIL.innerHTML = `<span class="summary-error"><strong>${_descriptionField}</strong>&nbsp${v}</span>`;
                    _HtmlUL.appendChild(_HtmlIL);
                })
                // _errorSumaryHTML.appendChild(_HtmlUL);
                new Alert_JS(_HtmlUL.outerHTML, JFMUI_CONST.ICONS.DANGER).show(_errorSumaryHTML);
            }
            // set focus to the first incorrect field.
            _response.Errors.keys().next().value.focus();
        } else {
            //get fields to send
            objectFields = this.getObjectFromFields(this.FieldCollection);
            // get data list fiels
            objectFields = this.getArrayFromTemplate(objectFields, this.Container, 1);
            objectFields.ReCaptchaToken = this.HasRecaptcha ? this.WidgetRecaptcha.getCaptchaResponse() : '';
        }

        /**
         * @type {FORM_RESULT}
         */
        const _formResult = {
            IsValid: (!this.OnBeforeSubmit || !!this.OnBeforeSubmit(_response, objectFields)) && _response.IsValid,
            Fields: objectFields
        };
        
        if (_formResult.IsValid) {
            if (this.EnableAjax) {
                this.SendDataByAjax(_formResult.Fields);
            } else {
                this.enableSpinnerOnButtons();
                this.Container.submit()
            }
        }
        //enable submit button 
        this.IsSubmitEnable = true;
        this.WidgetRecaptcha.reset();
    }
    /**
     * Build Object Data
     * @param {HTMLInputElement|HTMLTextAreaElement} pObjFields fields to convert.
     * @returns {Object} Object Data.
     */
    getObjectFromFields(pObjFields) {
        let objRoot = {};

        pObjFields.forEach((f) => {
            let dataObject = f.dataset.fieldObject; //output property name
            if (!!dataObject) {
                // get property value from input field.
                objRoot = this.buildObjectFromData(objRoot, dataObject, f);
            }
        });
        return objRoot;
    }
    /**
     * Add list item property to the root object.
     * @param {Object} pObjRoot 
     * @param {HTMLElement} pScope searching scope.
     * @param {Number} pLevel nested level
     * @returns {Object} root object
     */
    getArrayFromTemplate(pObjRoot, pScope, pLevel = 1) {
        let arrObject = [],
            arrayListContainer = pScope.querySelectorAll(`ul[data-list-level="${pLevel}"]`);
        if (!!arrayListContainer && arrayListContainer.length > 0) {
            // get array of list objects
            arrObject = Array.from(arrayListContainer).map(ul => this.getArrayFromList(ul, pLevel));
            // convert array of objects to a single object
            arrObject = arrObject.reduce((pV, cV) => pV = {
                ...pV,
                ...cV
            }, {});
            Object.assign(pObjRoot, arrObject);
        }
        return pObjRoot;
    }
    /**
     * get array of Objects from LI elements.
     * @param {HTMLUListElement} pUL 
     * @param {Number} pLevel nested level
     * @returns {Object} List field Object.
     */
    getArrayFromList(pUL, pLevel) {
        let objRoot = {},
            dataListContainer = pUL.dataset.listContainer,
            HTMLLICollection = null

        if (!!dataListContainer) {
            objRoot[dataListContainer] = [];
            HTMLLICollection = [].slice.call(pUL.children, 0).filter(child => child.tagName == 'LI');
            if (!!HTMLLICollection) {
                objRoot[dataListContainer] = [].slice.call(HTMLLICollection, 0).map(li => {
                    let root = {}
                    let fieldList = null

                    if (!!li.dataset.listFieldObject && !!li.dataset.listItemValue) {
                        root = this.buildObjectFromData(root, li.dataset.listFieldObject, undefined, li.dataset.listItemValue);
                        fieldList = Array.from(li.querySelectorAll('input[data-list-field-object],textarea[data-list-field-object]')).filter(f => f.closest(`li`) === li);
                        fieldList.forEach(f => {
                            root = this.buildObjectFromData(root, f.dataset.listFieldObject, f);
                        });
                        root = this.getArrayFromTemplate(root, li, ++pLevel)
                    }

                    return root;
                });
            }
        }

        return objRoot;
    }
    /**
     * Build object of fields
     * @param {Object} pObjRoot object root.
     * @param {String} pPath property path.
     * @param {HTMLInputElement|HTMLTextAreaElement} pHTMLInput input field.
     * @param {any} pPropertyValue property value.
     * @returns {Object} object of fields
     */
    buildObjectFromData(pObjRoot, pPath, pHTMLInput, pPropertyValue = '') {
        const arrFieldPatch = pPath.split('.').map((item) => item.trim()); // path string
        let objResp = pObjRoot, // root object
            propertyValue = pPropertyValue; // output property value

        // get property value from input field.
        if (!propertyValue) {
            switch (pHTMLInput.type.toLowerCase()) {
                case 'checkbox':
                    propertyValue = pHTMLInput.checked;
                    break;
                case 'radio':
                    propertyValue = this.Container.querySelector(`input[type="radio"][name="${pHTMLInput.name}"]:checked`).value;
                    break;
                case "select-one":
                case "select-multiple":
                    for (let index = 0, selectOption = null, optionValue = ''; index < pHTMLInput.options.length; index++) {
                        if (pHTMLInput.options[index].selected) {
                            selectOption = pHTMLInput.options[index];
                            if (selectOption.hasAttribute) {
                                optionValue = (selectOption.hasAttribute("value") ? selectOption.value : selectOption.text);
                            } else {
                                optionValue = (selectOption.attributes['value'].specified ? selectOption.value : selectOption.text);
                            }
                            propertyValue += optionValue + '&';
                        }
                    }
                    if (propertyValue.lastIndexOf("&") > -1) {
                        propertyValue = propertyValue.slice(0, propertyValue.lastIndexOf("&"));
                    }
                    break;
                case "file":
                    for (let index = 0; index < pHTMLInput.files.length; index++) {
                        propertyValue += pHTMLInput.files[index].name + '&';
                    }
                    if (propertyValue.lastIndexOf("&") > -1) {
                        propertyValue = propertyValue.slice(0, propertyValue.lastIndexOf("&"));
                    }
                    break;
                default:
                    // includes textarea also
                    propertyValue = pHTMLInput.value;
            }
        }

        // build the object like a linked list
        arrFieldPatch.forEach((currentValue, index, arr) => {
            if (index == (arr.length - 1)) {
                objResp[currentValue] = propertyValue;
            } else {
                if (!objResp[currentValue]) {
                    objResp[currentValue] = {}
                }
            }
            objResp = objResp[currentValue];
        });

        return pObjRoot;
    }

    /**
     * load object fields into the form.
     * @param {Object} pData data to fill the form.
     * @param {String} pPath object path
     */
    loadData(pData, pPath) {
        let _HTMLField = null, //HTML element
            _radioField = null; // radio type input

        pPath = !!pPath ? `${pPath}.` : ''; // add '.' accessor
        //iterate on object properties
        for (let prop in pData) {
            if (Array.isArray(pData[prop])) {
                // decompose array elements.
                pData[prop].forEach(pElem => this.loadDataList(pElem, this.Container, `${prop}`));
            } else if (typeof pData[prop] == 'object') {
                //descompe objects in inner properties.
                !!pData[prop] && this.loadData(pData[prop], `${pPath}${prop}`);
            } else if (typeof pData[prop] == 'string' || typeof pData[prop] == 'number' || typeof pData[prop] == 'boolean') {
                // assign values to the form
                _HTMLField = this.Container.querySelector(`[data-field-object="${pPath}${prop}"]`); //get html element.

                if (_HTMLField instanceof HTMLInputElement || _HTMLField instanceof HTMLTextAreaElement || _HTMLField instanceof HTMLSelectElement) {
                    // processs input o textarea
                    switch (_HTMLField.type) {
                        case 'checkbox':
                            _HTMLField.checked = !!pData[prop];
                            break;
                        case 'radio':
                            _radioField = this.Container.querySelector(`input[type="radio"][name="${_HTMLField.name}"][value="${pData[prop].toString().trim()}"]`);
                            !!_radioField && (_radioField.checked = true);
                            break;
                        case "select-one":
                        case "select-multiple":
                            [].slice.call(_HTMLField.options, 0).some(o => {
                                return (o.value == pData[prop].toString().trim()) && (o.selected = true);
                            });
                            break;
                        case 'file':
                            //reset input file.
                            _HTMLField.value = null;
                            break;
                        default:
                            //textarea value or another input type element.
                            _HTMLField.value = pData[prop].toString().trim();
                    }
                } else if (!!_HTMLField) {
                    _HTMLField.innerText = pData[prop].toString().trim(); //insert string in common tag element.
                }
            }
        }
    }
    /**
     * build html template for array values.
     * @param {Object} pData data object.
     * @param {HTMLElement} pScope container scope.
     * @param {String} pPath path to property.
     * @param {HTMLElement} pHTMLTemplate html template in memory only.
     * @param {HTMLElement} pHTMLParent html element where pHTMLTemplate is appended to.
     */
    // loadDataList(pData, pListContainer, pScope, pPath, pHTMLTemplate, pHTMLParent) {
    loadDataList(pData, pScope, pPath, pHTMLTemplate = null, pHTMLParent = null) {
        /**
         * @type {HTMLTemplateElement}
         */
        let _Template = null, //template element
            _HTMLParent = null, //list container
            _HTMLTemplate = null, //cloned document fragment
            _HTMLField = null, // text input
            _radioField = null; // radio input
        // get template node.
        if (!!pHTMLTemplate) {
            _HTMLTemplate = pHTMLTemplate;
        } else {
            _Template = document.querySelector(`template[data-list-template="${pPath}"]`);
            if (!!_Template) {
                _HTMLTemplate = _Template.content.cloneNode(true);
            } else {
                return;
            }
        }
        // get parent element.
        if (!!pHTMLParent) {
            _HTMLParent = pHTMLParent;
        } else {
            _HTMLParent = pScope.querySelector(`[data-list-container="${pPath}"]`);
            if (!_HTMLParent) {
                return;
            }
        }
        //Clean property array name
        !pHTMLTemplate && !pHTMLParent && (pPath = '');

        for (let prop in pData) {
            if (Array.isArray(pData[prop])) {
                // descompe array elements.
                pData[prop].forEach(pData => this.loadDataList(pData, _HTMLTemplate, `${prop}`));
            } else if (typeof pData[prop] == 'object') {
                //descompose object
                !!pData[prop] && this.loadDataList(pData[prop], null, `${pPath}${prop}.`, _HTMLTemplate, _HTMLParent);
            } else if (typeof pData[prop] == 'string' || typeof pData[prop] == 'number' || typeof pData[prop] == 'boolean') {
                // process single properties
                !!_HTMLTemplate && (_HTMLField = _HTMLTemplate.querySelector(`[data-list-field-object="${pPath}${prop}"]`));
                if (_HTMLField instanceof HTMLInputElement || _HTMLField instanceof HTMLTextAreaElement) {
                    switch (_HTMLField.type) {
                        case 'checkbox':
                            _HTMLField.checked = !!pData[prop];
                            break;
                        case 'radio':
                            _radioField = _HTMLTemplate.querySelector(`input[type="radio"][name="${_HTMLField.name}"][value="${pData[prop].toString().trim()}"]`);
                            !!_radioField && (_radioField.checked = true);
                            break;
                        case "select-one":
                        case "select-multiple":
                            [].slice.call(_HTMLField.options, 0).some(o => {
                                return (o.value == pData[prop].toString().trim()) && (o.selected = true);
                            });
                            break;
                        case 'file':
                            _HTMLField.value = null;
                            break;
                        default:
                            _HTMLField.value = pData[prop].toString().trim();
                    }
                } else if (!!_HTMLField) {
                    if (!!_HTMLField.dataset.listItemValue) {
                        _HTMLField.dataset.listItemValue = pData[prop].toString().trim();
                    } else {
                        _HTMLField.innerText = pData[prop].toString().trim();
                    }
                }
            }
        }
        // add template to the form.
        !pHTMLParent && !!_HTMLParent && (_HTMLParent.appendChild(_HTMLTemplate));
    }
    /**
     * TODO: implement AJAX functionality
     */
    SendDataByAjax(pFields) {
        console.log('sended data');
        // new AJAXCommunications_JS({
        //     method: this.Submit.method,
        //     url: this.Submit.url,
        //     data: formData,
        //     mode: JFM_CONST.FETCHMODES.SAMEORIGIN,
        //     contentType: null,
        //     FnSuccess: this.onSuccessSubmit.bind(this),
        //     FnError: this.onFailureSubmit.bind(this),
        //     FnBeforeSend: this.onBeginSubmit.bind(this),
        //     FnComplete: this.onCompleteSubmit.bind(this),
        // }).AsyncFetch();
    }
    /**
     * process submit event
     * @param {Event} event event object
     * @returns {Boolean}
     */
    onSubmit(event) {
        if (!!this.confirmTxt) {
            // cancel flow if user abort operation.
            new PopUpConfirm_JS(this.ConfirmTxt, '', undefined, undefined, undefined, true).show(this.sendForm.bind(this));
        } else {
            // process to validate form and send.
            this.sendForm();
        }
        event.stopPropagation();
        event.preventDefault();
        return false;
    }
    /**
     * Enable spinners on submit buttons
     */
    enableSpinnerOnButtons() {
        this.IsSubmitEnable = false;
        const _htmlDiv = document.createElement('DIV');
        const _htmlSpinner = '<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>';
        const _htmlEnviando = '<span role="status">Enviando...</span>';

        _htmlDiv.insertAdjacentHTML('beforeend', _htmlSpinner);
        _htmlDiv.insertAdjacentHTML('beforeend', _htmlEnviando);

        this.SubmitBtnCollection.forEach(btn => {
            const _clonedDiv = _htmlDiv.cloneNode(true);
            btn.innerHTML = _clonedDiv.innerHTML;
            btn.style.display = "flex";
            btn.style.alignItems = "center";
            btn.style.gap = ".25rem";
        });
    }
}